import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { Spotlight } from 'components/core/spotlight';
import { clearAutoShareSpotlight } from '../modals/auto_share_discovery_modal/auto_share_discovery_modal_slice';
import { autoShareSpotlightTypeSelector, shouldShowAutoShareSpotlightSelector } from '../selectors';
const styledSpotlightCss = "s115b833";
const containerCss = "cotpf6";
const StyledSpotlight = props => <Spotlight {...props} className={classNames(styledSpotlightCss, props.className)} />;
const NotetakerSettingsButton = props => <MinimalButton {...props} />;
const NotetakerSettingsButtonWithSpotlight = props => {
  const dispatch = useDispatch();
  const spotlightType = useSelector(autoShareSpotlightTypeSelector);
  const handleSpotlightClick = () => {
    dispatch(clearAutoShareSpotlight());
  };
  const headingText = spotlightType === 'enabled' ? I18n.t('publisher.meeting_intelligence.auto_share.spotlight.enabled.title') : I18n.t('publisher.meeting_intelligence.auto_share.spotlight.deferred.title');
  const bodyText = spotlightType === 'enabled' ? HtmlParser(I18n.t('publisher.meeting_intelligence.auto_share.spotlight.enabled.body')) : HtmlParser(I18n.t('publisher.meeting_intelligence.auto_share.spotlight.deferred.body'));
  return <div className={containerCss}>
      <MinimalButton {...props}>
        {props.children}
      </MinimalButton>
      <StyledSpotlight headingText={headingText} bodyText={bodyText} onClose={handleSpotlightClick} onClickPrimary={handleSpotlightClick} placement="bottom-left" offset={20} outsideClickDetectionEnabled={false} showClose={false} primaryButtonLabel={I18n.t('publisher.meeting_intelligence.auto_share.spotlight.button')} theme="classic" />
    </div>;
};
export const NotetakerSettingsButtonWithSpotlightWrapper = props => {
  const showSpotlight = useSelector(shouldShowAutoShareSpotlightSelector);
  return showSpotlight ? <NotetakerSettingsButtonWithSpotlight {...props} /> : <NotetakerSettingsButton {...props} />;
};

require("./notetaker_settings_button_with_spotlight.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./notetaker_settings_button_with_spotlight.js");